import { AnimatePresence, motion } from 'framer-motion';
import * as React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { messagesData } from '../../../Shared/RecentActAndMessagesData';
import { MessageInbox } from './MessageInbox/MessageInbox';

import './Messages.scss';


export interface IMessagesProps {
    setMessageOpen: any,
    peoplesWithInboxData: any,
    newInboxDataPubProfile: any,
}

export function Messages({ peoplesWithInboxData, newInboxDataPubProfile, setMessageOpen }: IMessagesProps) {
    // const [peoplesWithInboxData, setPeoplesWithInboxData] = useState(messagesData);

    const navigate = useNavigate()

    const [inboxMessagesShow, setInboxMessagesShow] = useState({
        isOpen: false,
        inboxData: [],
    });
    const handlePeopleOnClick = (inboxData: any) => {
        // console.log(inboxData);
        setInboxMessagesShow({ isOpen: true, inboxData: inboxData, })
    }



    useEffect(() => {
        if (newInboxDataPubProfile && newInboxDataPubProfile.inboxMessages) {
            setInboxMessagesShow({ isOpen: true, inboxData: newInboxDataPubProfile.inboxMessages, })
        } else {
            setInboxMessagesShow({ isOpen: false, inboxData: [], })
        }
    }, [])



    return (
        <motion.div
            initial={{ opacity: 0, }}
            animate={{ opacity: 1, }}
            exit={{ opacity: 0, }}
            className="messages_main_box 
            overflow-hidden fixed
            top-[0px] w-full bottom-0 right-0
            md:top-[80px] md:w-[454.67px]
            border-l-2 dark:border-0
            shadow-2xl dark:bg-[#271F54] bg-[#F5F5F5]
            pb-[145px]
            xxsm:pb-[131px] border-2
            sm:pb-[134px]">


            <div className="xs:py-4 sm:py-10 xs:px-5 sm:px-8 w-full bg-[#e0e0e0] dark:bg-[#3B316E] flex justify-start items-start">
                <button onClick={() => setMessageOpen(false)} className="mr-2 mt-0.5 md:hidden">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 stroke-cusBlack dark:stroke-white" fill="none" viewBox="0 0 24 24" stroke="" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                    </svg>
                </button>

                <div className="text-left">
                    <h4 className="text-cusBlack dark:font-normal font-extrabold dark:text-white xs:text-lg ">UNC global Chat</h4>
                    <p className="text-l-LightBlack dark:text-cusBlueWhite xs:text-xs sm:text-sm sm:mt-1">Connect & exchange your thoughts globally </p>
                </div>
            </div>




            <div className="flex flex-col h-full overflow-auto px-2 py-2">
                {peoplesWithInboxData.map((people: any) =>
                    <div key={people.id}
                        onClick={() => handlePeopleOnClick(people.inboxMessages)}
                        className="flex justify-start items-center p-3 hover:bg-[#e8e8e8] dark:hover:bg-[#1e1843] rounded-xl transition-all cursor-pointer">


                        {people.isGroup && people.groupProfilePhoto
                            ? <div className="flex mt-3">
                                <div>
                                    <div className="w-7 h-7 sm:w-8 sm:h-8 md:w-[40px] md:h-[40px] rounded-full overflow-hidden">
                                        <img src={people.groupProfilePhoto[0]} alt="" />
                                    </div>
                                </div>
                                <div>
                                    <div className="w-7 h-7 sm:w-8 sm:h-8 md:w-9 md:h-9 rounded-full overflow-hidden -ml-5 -mt-3 relative">
                                        <img src={people.groupProfilePhoto[1]} alt="" />
                                    </div>
                                </div>
                            </div>

                            : <div>
                                <div className="w-9 h-9 sm:w-11 sm:h-11 md:w-14 md:h-14 rounded-full overflow-hidden">
                                    <img src={people.chatProfilePhoto} alt="" />
                                </div>
                            </div>
                        }


                        <div className="ml-3 text-left w-10/12">
                            <h5 className="text-cusBlack dark:text-white text-sm sm:text-base md:text-lg flex">{people.name}</h5>

                            {people.inboxMessages.length > 0 &&
                                <div className="flex justify-between items-center">
                                    <p className="text-cusBlack dark:text-white text-xs md:text-sm break-all whitespace-nowrap overflow-hidden overflow-ellipsis w-9/12">
                                        {people.inboxMessages[people.inboxMessages.length - 1].isItMyMessage && "You: "}
                                        {
                                            people.inboxMessages[people.inboxMessages.length - 1].messageText
                                                ? people.inboxMessages[people.inboxMessages.length - 1].messageText
                                                : people.inboxMessages[people.inboxMessages.length - 1].messageAudio
                                                    ? "You: Sent a Audio"
                                                    : <>
                                                        {people.inboxMessages[people.inboxMessages.length - 1].messageGifs && "Sent a Gifs"}
                                                        {people.inboxMessages[people.inboxMessages.length - 1].messagePhotoVideo && ", Photo/Video "}
                                                    </>
                                        }
                                    </p>

                                    <p className="text-cusBlack dark:text-white text-xs md:text-sm break-all whitespace-nowrap overflow-hidden overflow-ellipsis">
                                        {people.inboxMessages[people.inboxMessages.length - 1].messageSentTime}
                                    </p>
                                </div>}

                        </div>


                    </div>
                )}
            </div>





            {/* {newInboxDataPubProfile && newInboxDataPubProfile.inboxMessages
                ? <AnimatePresence>
                    <MessageInbox inboxMessages={newInboxDataPubProfile.inboxMessages} setInboxMessagesShow={setInboxMessagesShow} />
                </AnimatePresence>

                : <AnimatePresence>
                    {inboxMessagesShow.isOpen &&
                        <MessageInbox inboxMessages={inboxMessagesShow.inboxData} setInboxMessagesShow={setInboxMessagesShow} />
                    }
                </AnimatePresence>
            } */}

            <AnimatePresence>
                {inboxMessagesShow.isOpen &&
                    <MessageInbox inboxMessages={inboxMessagesShow.inboxData} setInboxMessagesShow={setInboxMessagesShow} />
                }
            </AnimatePresence>



        </motion.div>
    );

}
